module.exports = __webpack_public_path__ + "img/ONESTORE.e4177b5f.png";